/**
 * Shortcut glyphs shown in the shell. The listeners accept Ctrl and Meta;
 * this only decides which one the UI claims to bind.
 *
 * Apple platforms get the compact glyphs the handoff uses. Everything else
 * gets an explicit Ctrl+ chord so Windows/Linux users are not told to press
 * a key they do not have.
 */
const isApplePlatform = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const platform = navigator.platform || '';
  const ua = navigator.userAgent || '';
  return /Mac|iPhone|iPad|iPod/.test(platform) || /Mac OS X/.test(ua);
};

export const shellSearchShortcut = (): string => (isApplePlatform() ? '⌘K' : 'Ctrl+K');

export const shellViewAsShortcut = (): string =>
  isApplePlatform() ? '⌘⇧U' : 'Ctrl+Shift+U';
